package site.shadadman.pages.worklog.SportsGameX

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initSportsGameXPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/SportsGameX/SportsGameX.md", FrontMatterElement.Builder { addScalar("title", "SportsGameX Worklog"); }))
}

@Page("/worklog/SportsGameX/sports-game-x")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun SportsGameXPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("sportsgamex") }) {
        org.jetbrains.compose.web.dom.Text("SportsGameX")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/SportsGameX/apr92025SportsGamexFirstSprint") {
                org.jetbrains.compose.web.dom.Text("First Sprint")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/SportsGameX/jul32025SportsGamexFirebaseAnalytics") {
                org.jetbrains.compose.web.dom.Text("Firebase Analytics")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/SportsGameX/jul302025SportsGamexTradingViewCharts") {
                org.jetbrains.compose.web.dom.Text("TradingView Charts")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/SportsGameX/aug122025SportsGameXMLModel") {
                org.jetbrains.compose.web.dom.Text("ML Model")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/SportsGameX/aug172025SportsGameXGoogleSignin") {
                org.jetbrains.compose.web.dom.Text("Google Signin")
            }
        }
        org.jetbrains.compose.web.dom.Li {
            com.varabyte.kobweb.silk.components.navigation.Link("/worklog/SportsGameX/jun122025SportsGameXKMPIntegration") {
                org.jetbrains.compose.web.dom.Text("KMP Integration")
            }
        }
    }
}
